// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface PlugIconSignature {
  Element: SVGSVGElement;
}

export const PlugIcon: TOC<PlugIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M16 5H18C19.103 5 20 5.896 20 7V10C20 14.073 16.94 17.436 13 17.931V21H11V17.931C7.06 17.436 4 14.072 4 10V7C4 5.896 4.897 5 6 5H8V2H10V5H14V2H16V5ZM13.0607 13.5606C13.6465 12.9748 13.6465 12.0251 13.0607 11.4393C12.4749 10.8535 11.5252 10.8535 10.9394 11.4393C10.3536 12.0251 10.3536 12.9748 10.9394 13.5606C11.5252 14.1464 12.4749 14.1464 13.0607 13.5606ZM18 7V8H6V7H18ZM6 10C6 13.309 8.691 16 12 16C15.309 16 18 13.309 18 10H6Z"/>
</svg>
</template>;